import { errorMessageWithFallback } from '../../utils/errorMessages';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorAlert = ({
  currentError,
  setTwoFactorError
}) => /*#__PURE__*/_jsx(View, {
  marginBlockStart: "400",
  as: "div",
  children: /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: I18n.text(`reAuth.error.${errorMessageWithFallback(currentError)}.title`, {
      errorCode: currentError
    }),
    closeable: true,
    onClose: () => {
      setTwoFactorError('');
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reAuth.error.${errorMessageWithFallback(currentError)}.desc`,
      options: {
        errorCode: currentError
      }
    })
  })
});
export default ErrorAlert;